<template>

  <div class="phone-number-input mb-3">
    <b for="name" v-if="label" class="form-label"> {{ label }} </b>
    <input v-model="phoneNumber" type="tel" :placeholder="label" :disabled="disabled" :readonly="readonly"
      @input="handleInput" class="form-control" />
    <span v-if="errorMessage" class="text-danger">{{ errorMessage }}</span>
    <span class="text-danger" v-for="error in v?.$errors" :key="error.$uid">
      - {{ error.$message }} <br>
    </span>
  </div>

</template>

<script setup lang="ts">
import { ref, watch, defineProps, defineEmits } from 'vue';


const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  label: String,
  placeholder: {
    type: String,
    default: 'Enter phone number',
  },
  disabled: Boolean,
  readonly: Boolean,
  v: {
    type: Object,
  },
});

const phoneNumber = ref(props.modelValue);
const errorMessage = ref('');
const emits = defineEmits(['update:modelValue']);


const handleInput = () => {
  // Remove non-numeric characters from phone number
  phoneNumber.value = phoneNumber.value.replace(/\D/g, '');

  // Emit the sanitized phone number
  emits('update:modelValue', phoneNumber.value ?? '');
 
}; 

watch(() => props.modelValue, (newValue) => {
  phoneNumber.value = newValue; 
});


</script>

<style>
/* Add any necessary styles here */
</style>
